<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-spacer></v-spacer>
        <v-toolbar-title>Income Statement</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row class="subtitle-2 text--primary d-flex justify-center align-center">
          <v-col cols="7">
            <!-- sales table -->
            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td style="text-align: left;">Net Sales</td>
                    <td style="text-align: right;">{{ incomeStatement.totalRevenue | currency }}</td>
                  </tr>
                  <tr>
                    <td style="text-align: left;">Cost of Sales</td>
                    <td style="text-align: right;">{{ incomeStatement.totalCostOfGoods | currency }}</td>
                  </tr>
                  <tr>
                    <td>
                      <div style="margin-left: 40px;">Gross Margin</div>
                    </td>
                    <td
                      style="text-align: right; text-decoration: underline;"
                    >{{ incomeStatement.grossMargin | currency }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <!-- end -->

            <v-simple-table dense class="mt-2">
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td style="text-align: left;">Expenditure</td>
                    <td style="text-align: right;"></td>
                  </tr>
                  <tr v-for="(expense, index) of incomeStatement.expenses" v-bind:key="index">
                    <td style="text-align: left;">
                      <div style="margin-left: 40px;"> {{ expense.account }}</div>
                    </td>
                    <td style="text-align: right;">{{ expense.balance | currency }}</td>
                  </tr>
                 
                </tbody>
              </template>
            </v-simple-table>

            <!-- expenditure table -->
            <v-simple-table dense class="mt-2">
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>
                      <div style="margin-left: 40px;">Total Expenditure</div>
                    </td>
                    <td
                      style="text-align: right; text-decoration: underline;"
                    >{{ incomeStatement.totalExpenditure | currency }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <!-- end -->

            <!-- net income table -->
            <v-simple-table dense class="mt-2">
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td style="text-align: left;">Net Income</td>
                    <td
                      style="text-align: right; text-decoration: underline;"
                    >{{ incomeStatement.netIncome | currency }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>
  
  <script>
export default {
  data: () => ({
    search: "",
    zeroValue: 0,
    incomeStatement: {}
  }),
  methods: {
    getReport() {
      const self = this;
      this.$store
        .dispatch("get", `/income-statement`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.incomeStatement = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    this.getReport();
  }
};
</script>